import type { GscKeyword } from "../../../types";

type Metrics = {
    trackedKeywords: number;
    impressionsRatio: number;
    clicksRatio: number;
};

/**
 * Return data for the metric cards
 * @param keywords are pre-sorted by clicks (desc) from the API, so "first N" = "top N by clicks"
 * @param selectedCount selected number of keywords
 */
export const getKeywordMetrics = (keywords: GscKeyword[], selectedCount: number): Metrics => {
    let totalClicks = 0;
    let totalImpressions = 0;
    let selectedClicks = 0;
    let selectedImpressions = 0;

    for (let i = 0; i < keywords.length; i++) {
        const kw = keywords[i];
        totalClicks += kw.clicks;
        totalImpressions += kw.impressions;
        if (i < selectedCount) {
            selectedClicks += kw.clicks;
            selectedImpressions += kw.impressions;
        }
    }

    return {
        trackedKeywords: selectedCount,
        impressionsRatio: totalImpressions > 0 ? selectedImpressions / totalImpressions : 0,
        clicksRatio: totalClicks > 0 ? selectedClicks / totalClicks : 0,
    };
};
